export default __webpack_public_path__ + "static/media/room3-MULTIPLY-shadow.0855c401.png";